/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function () {
  'use strict';
  /**
   * Хелпер для форматирования даты
   * @type {{asSocialDate: app.helpers.DateHelper.asSocialDate}}
   */
  app.helpers.DateHelper = {
    asSocialDate: function (date, format, dateOnly) {
      moment.locale('ru');
      /*
       * Дата с сервера приходит в таком формате 2013-01-01 01:01:01+05,
       * Internet explorer и Safari не воспринимают такую дату в строковом виде,
       * поэтому создаем объект даты через moment.js
       */
      var d = moment(date).toDate(),
        dateFormat,
        yesterday = new Date(moment().subtract(1, 'day').toISOString()),
        currentYear = new Date().getFullYear(),
        reviewYear = d.getFullYear(),
        currentMonth = new Date().getMonth(),
        currentDay = new Date().getDate(),
        reviewMonth = d.getMonth(),
        reviewDay = d.getDate();
      if (format) {
        return moment(d).format(format);
      }
      if (
        yesterday.getDate() === reviewDay
        && yesterday.getMonth() === reviewMonth
        && yesterday.getFullYear() === reviewYear
      ) {
        return 'вчера ' + moment(d).format('HH:mm');
      }
      if (reviewYear === currentYear) {
        if (currentMonth === reviewMonth) {
          if (reviewDay === currentDay) {
            dateFormat = moment(d).format('HH:mm');
            if (dateOnly) {
              dateFormat = 'сегодня';
            }
          } else {
            dateFormat = moment(d).format('DD MMMM');
          }
        } else {
          dateFormat = moment(d).format('DD MMMM');
        }
      } else {
        dateFormat = moment(d).format('DD MMMM YYYY');
      }
      return dateFormat;
    },
    /**
     * Парсит дату из строки формата DD.MM.YYYY в объект Date()
     * @param dateString Исходное строковое представление даты
     * @returns {Date|null}
     */
    parseRussianDate: function (dateString) {
      if (dateString && _.isString(dateString) && dateString.split('.').length === 3) {
        moment.locale('ru');
        return new Date(moment(dateString, 'DD.MM.YYYY').toISOString());
      }
      return null;
    },
    /** Возвращает текст с датами на основе двух дат.
     * @param {string} startDate Начальная дата доставки.
     * @param {string} [endDate] Конечная дата доставки.
     * @returns {string} Текст с информацией о сроках доставки.
     */
    getDatesIntervalText: function (startDate, endDate, separator) {
      var timeFormats = ['YYYY-MM-DD', 'DD.MM.YYYY'];
      var start = moment(startDate, timeFormats);
      var end = moment(endDate, timeFormats);
      var readySeparator = ' ' + (separator || '-') + ' ';
      var result = '';
      if (start.isValid() && end.isValid() && start.valueOf() !== end.valueOf()) {
        var startFormattedDate = start.month() === end.month()
          ? start.format('D')
          : start.format('D MMMM');
        result = startFormattedDate + readySeparator + end.format('D MMMM');
      } else if (start.isValid()) {
        result = start.format('D MMMM');
      }
      return result;
    }
  };
})();

}.call(window));